export default {
    XS_MAX_WIDTH: 575,
    SM_MIN_WIDTH: 576,
    SM_MAX_WIDTH: 767,
    MD_MIN_WIDTH: 768,
    MD_MAX_WIDTH: 991,
    LG_MIN_WIDTH: 992,
    LG_MAX_WIDTH: 1199,
    XL_MIN_WIDTH: 1200
}



// WEBPACK FOOTER //
// ./src/common/constants/layout.js